import { Component, Input, OnInit, ViewChild, input, output } from '@angular/core';
import { Observable, of } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UnsubscribeOnDestroy } from '../../classes';
import { ModalService } from '../../services';
import { TooltipModule } from 'primeng/tooltip';
import { Button, ButtonModule } from 'primeng/button';


@Component({
    selector: 'modal-form',
    templateUrl: './modalform.component.html',
    styleUrls: ['./modalform.component.scss'],
    standalone: true,
    imports: [Button, ButtonModule, TooltipModule]
})
export class ModalformComponent  extends UnsubscribeOnDestroy {
  showModal: boolean = false;
  disableCancel: boolean = false;
  hideOk: boolean = false;
  hideCancel: boolean = false;
  hideHeader: boolean = false;

  readonly action = output<boolean>({ alias: 'action' });
  readonly actionCancel = output<boolean>({ alias: 'actionCancel' });
  readonly validationFailed = output<any>({ alias: 'validationFailed' });
  // TODO: Skipped for migration because:
  //  Complex Observable type may contain DataView objects that cause read-only errors.
  @Input("isValid") isValid: boolean | Observable<boolean> = undefined;
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input("isDirty") isDirty: boolean = undefined;
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input("disableOk") disableOk: boolean = undefined;
  readonly confirmCount = input<number>(undefined);
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input("confirmButtonText") confirmButtonText: string = null;
  readonly confirmTooltip = input<string>(null);
  // TODO: Skipped for migration because:
  //  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
  //  and migrating would break narrowing currently.
  @Input("cancelButtonText") cancelButtonText: string = null;
  readonly isAutoSize = input<boolean>(false);
  readonly isWideModal = input<boolean>(false);
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input("closeOnSave") closeOnSave: boolean = true;

  constructor (private modalService: ModalService) { super(); }

  cancel (): void {
      if (this.isDirty) {
          this.modalService.showUnsavedModal()
              .pipe(takeUntil(this.ngUnsubscribe$))
              .subscribe((response) => {
                  if (response) {
                      this.showModal = false;
                 } else {
                      this.showModal = true;
                  }
              });
      } else {
          this.showModal = false;
      }

      //scrolls each modal content to the top on hide
      const modals = document.getElementsByClassName("modal-body");

      for (let i = 0; i < modals.length; i++) {
          modals[i].scrollTo(0, 0);
      }

      if (!this.showModal) {
          this.actionCancel.emit(true);
      }
  }

  ok (): void {
      const isValid = this.isValid;
      if (typeof isValid === "boolean") {
          if (!isValid) {
              // TODO: The 'emit' function requires a mandatory any argument
              this.validationFailed.emit(null);
              return;
          } else {
              this.showModal = !this.closeOnSave;
              this.action.emit(true);
          }
      }
      else {
          of(isValid)
          .pipe(takeUntil(this.ngUnsubscribe$))
          .subscribe((val) => {
              if (!val) {
                  // TODO: The 'emit' function requires a mandatory any argument
                  this.validationFailed.emit(null);
                  return;
              } else {
                  this.showModal = !this.closeOnSave;
                  this.action.emit(true);
              }
          });
      }
  }
}
